import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { deleteUser, selectDeleteUserStatus } from "./usersSlice";
import {
  Alert,
  Box,
  Button,
  Container,
  Dialog,
  Snackbar,
  Typography,
} from "@mui/material";
import { NewUserBodyType } from "./usersAPI";
import LoadingButton from "../shared/LoadingButton";
import { StatusType } from "../../app/constants";

export default function DeleteUser({
  open,
  onClose,
  currentUser,
}: {
  open: boolean;
  onClose: () => void;
  currentUser: NewUserBodyType;
}) {
  const status = useAppSelector(selectDeleteUserStatus);

  const [openSnackbar, setOpenSnackbar] = useState(false);

  const dispatch = useAppDispatch();

  const onConfirmDelete = () => {
    if (currentUser._id)
      dispatch(deleteUser(currentUser._id)).then(() => {
        setOpenSnackbar(true);
        onClose();
      });
  };

  const handleCloseSnackbar = (
    event?: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnackbar(false);
  };

  return (
    <>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={status === StatusType.failed ? "error" : "success"}
          sx={{ width: "100%" }}
        >
          {status === StatusType.failed
            ? "Ocurrió un error al eliminar al usuario, intente nuevamente."
            : "Usuario eliminado"}
        </Alert>
      </Snackbar>
      <Dialog open={open} onClose={onClose}>
        <Container
          component="main"
          maxWidth="lg"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "flex-start",
            marginTop: 4,
            marginBottom: 4,
          }}
        >
          <Typography variant="h5" component="h1" gutterBottom align="center">
            Estas seguro de que quieres eliminar el usuario {currentUser.email}?
          </Typography>

          <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
            <Button
              type="button"
              onClick={onClose}
              sx={{ flex: 1, mt: 3, mb: 2, marginRight: 2 }}
            >
              Cancelar
            </Button>

            <LoadingButton
              sx={{ flex: 1 }}
              loading={status === StatusType.loading}
              text="Eliminar"
              type="button"
              onClick={onConfirmDelete}
            />
          </Box>
        </Container>
      </Dialog>
    </>
  );
}
